/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BasicModel,
    BasicModelFromJSON,
    BasicModelToJSON,
    BasicValueModel,
    BasicValueModelFromJSON,
    BasicValueModelToJSON,
} from '../models';

/**
 * 
 */
export class CurrencyApi extends runtime.BaseAPI {

    /**
     * Admin, Lessor
     */
    async currencyExchangeRatesGetRaw(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Array<BasicValueModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/currency/exchange-rates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BasicValueModelFromJSON));
    }

    /**
     * Admin, Lessor
     */
    async currencyExchangeRatesGet(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Array<BasicValueModel>> {
        const response = await this.currencyExchangeRatesGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Captcha ( Guest = guest )
     */
    async currencyGetRaw(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Array<BasicModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/currency`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BasicModelFromJSON));
    }

    /**
     * Captcha ( Guest = guest )
     */
    async currencyGet(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Array<BasicModel>> {
        const response = await this.currencyGetRaw(initOverrides);
        return await response.value();
    }

}
